<app-loading-spinner *ngIf="loading"></app-loading-spinner>

<div class="contact-us-component">
  <h1 class="contact-us-component__title">{{ 'HOME.CONTACT US' | translate }}</h1>
  <form class="flex flex-col gap-3 contact-us-component-form" [formGroup]="contactForm" *ngIf="contactForm">
    <app-input-set
      forLabel="name"
      label="HOME.CONTACT_FORM.FULL NAME"
      [control]="contactForm.controls.name"
      type="text"
      [submitting]="submitting"
      [isRequired]="true"
      format="text"
    ></app-input-set>
    <app-input-set
      forLabel="email"
      label="HOME.CONTACT_FORM.EMAIL"
      [control]="contactForm.controls.email"
      type="email"
      [submitting]="submitting"
      [isRequired]="true"
      format="email"
    ></app-input-set>
    <app-input-set
      forLabel="subject"
      label="HOME.CONTACT_FORM.SUBJECT"
      [control]="contactForm.controls.subject"
      type="text"
      [submitting]="submitting"
      [isRequired]="true"
      format="text"
    ></app-input-set>
    <app-input-set
      forLabel="subject"
      label="HOME.CONTACT_FORM.HOW CAN WE HELP"
      [control]="contactForm.controls.message"
      type="textarea"
      [submitting]="submitting"
      [isRequired]="true"
    ></app-input-set>
    <button
      systemButton
      buttonType="primary"
      type="button"
      (click)="sendEmail()"
      class="contact-us-component-form__button"
    >
      {{ 'HOME.CONTACT_FORM.SEND' | translate }}
    </button>
  </form>
</div>

<app-toast
  [message]="toastMessage"
  [type]="typeToastMessage"
  [showToast]="showToastMessage"
  (showToastChange)="showToastMessage = $event"
></app-toast>
